module.exports = __webpack_public_path__ + "img/lunchuan.55c2bcc9.png";